/* unplugin-vue-components disabled */import { render } from "./lang-sel.vue?vue&type=template&id=3554cb36"
import script from "./lang-sel.vue?vue&type=script&lang=js"
export * from "./lang-sel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__